import { createContext } from 'react';

const INITIAL_RISK_CONTEXT = { risk: null, fieldDefinition: null, riskfieldOptions: null };

export const RiskContext = createContext(INITIAL_RISK_CONTEXT);
